import { Icon } from '@aon/aon-tws-common-ui';
import { bodyCopyBold, errorText } from '@aon/aon-tws-common-ui/build/lib/globalCss';
import * as React from 'react';
import HtmlParser from 'html-react-parser';
import styled from 'styled-components';
import ContentConstants from '../../contentConstants';
import { SeverityType, SurveyStep } from '../../models';

export interface ISeverityDisplayProps {
	severity: SeverityType;
	message: string;
	showSeverityPrefix?: boolean;
	relatedStep?: SurveyStep;
	canJump?: boolean;
	Jump?: (relatedStep: SurveyStep) => void;
}

export const SeverityMessage = styled.div.attrs<{ canJump?: boolean; step?: SurveyStep }>({
	className: 'tws-confirm-severity-message',
})<{ canJump?: boolean; step?: SurveyStep }>`
	${errorText}
	padding: 3px 0;
	${(props) => (!props.canJump || !props.step ? 'pointer-events: none;' : 'cursor: pointer;')}
`;
SeverityMessage.displayName = 'SeverityMessage';

export const SeverityPrefix = styled.span`
	${bodyCopyBold}
`;

export const Bold = styled.strong``;

export class SeverityDisplay extends React.Component<ISeverityDisplayProps> {
	public render() {
		const { relatedStep, canJump } = this.props;

		return (
			<SeverityMessage canJump={canJump} step={relatedStep} onClick={() => this.props.Jump!(relatedStep!)}>
				{this.getSeverityPrefix()} {HtmlParser(this.props.message)}
			</SeverityMessage>
		);
	}

	public getSeverityPrefix() {
		switch (this.props.severity) {
			case SeverityType.Error:
				return (
					<>
						<Icon name='error' /> &nbsp;
						{this.props.showSeverityPrefix && (
							<>
								<Bold>{ContentConstants.ERROR}</Bold> -
							</>
						)}
					</>
				);
			case SeverityType.Warning:
				return (
					<>
						<Icon name='warning' />
						{this.props.showSeverityPrefix && (
							<>
								&nbsp;<Bold>{ContentConstants.WARNING}</Bold> -
							</>
						)}
					</>
				);
		}
	}
}
